import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#ddkyti2u8__clip0_small)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#nx8o7fvds__clip1_small)",
          children: [_jsx("rect", {
            x: "0",
            y: "3.6",
            width: "20",
            height: "2.4",
            fill: "#0038B8"
          }), _jsx("rect", {
            x: "0",
            y: "14",
            width: "20",
            height: "2.4",
            fill: "#0038B8"
          }), _jsxs("g", {
            stroke: "#0038B8",
            strokeWidth: "0.7",
            fill: "none",
            strokeLinejoin: "round",
            children: [_jsx("path", {
              d: "M10 6.8 L12.77 11.6 L7.23 11.6 Z"
            }), _jsx("path", {
              d: "M10 13.2 L7.23 8.4 L12.77 8.4 Z"
            })]
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "ddkyti2u8__clip0_small",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "nx8o7fvds__clip1_small",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            fill: "white"
          })
        })]
      })]
    }))
  });
};
export default Component;
